module.exports = __webpack_public_path__ + "e415e2db60b0d447687d05099f69850c.svg";